<template>
    <div>
        <navbar-header></navbar-header>
        <CookOrders class="body"></CookOrders>
    </div>
</template>

<script>
import NavbarHeader from '@/components/NavbarHeader'
import CookOrders from '@/components/CookOrders'
import {
  workshopsACT
} from '../constants/vuexActions'
export default {
  name: 'ProductLayouts',
  data () {
    return {
      statsTarget: null,
      motivRenewTimeout: null
    }
  },
  components: {
    CookOrders,
    NavbarHeader
  },
  computed: {
    percentInTarget () {
      let totalCount = this.statsTarget ? this.statsTarget.totalCount : 0
      if (totalCount > 0) {
        let targetCount = this.statsTarget.inTargetCount
        return targetCount / totalCount * 100
      }
      return 0
    }
  },
  created () {
    this.$store.dispatch(`workshops/${workshopsACT.REQUEST_MOTIVATE_INFO}`)
    this.motivRenewTimeout = setInterval(() => {
      this.$store.dispatch(`workshops/${workshopsACT.REQUEST_MOTIVATE_INFO}`)
    }, 300000)
  },
  beforeDestroy () {
    clearInterval(this.motivRenewTimeout)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/CookLayout.vue